<div *ngIf="!!files?.length" >
    <div class="header" [class.underline-primary]="showHeader">
        <h3 class="text-light font-weight-bold m-1" *ngIf="showHeader">FILES</h3>
        <app-dropdown-sort
          (select)="changeSorting($event)">
        </app-dropdown-sort>
      </div>
      <div class="tile-container">
        <ng-container *ngFor="let file of files; let i = index">
            <app-asset-tile
              *ngIf="i < 10"
              class="tile"
              [data]="file">
            </app-asset-tile>
        </ng-container>
      </div>
      <button class="btn btn-link link-arrow more-results float-right text-right text-uppercase pr-0 mr-0"
      [routerLink]="['files']"
      [queryParams]="{view: 'row'}"
      *ngIf="files?.length > 10">
      View all <i class="icon icon-arrow-fwd-sm-link"></i></button>
</div>
